import React, { useState } from 'react';
import {
  Button, Row, Spinner, Jumbotron, Col,
} from 'reactstrap';
import { useMutation } from '@apollo/react-hooks';
import { Alert } from '@material-ui/lab';
import { SET_TARGET_VERSION_TO_BOX } from '../../mutation/mutation';

export default () => {
  const [macAddress, setMacAddress] = useState('');
  const [targetVersion, setTargetVersion] = useState('');
  const [setTargetVersionToBox, { loading }] = useMutation(SET_TARGET_VERSION_TO_BOX);
  const [succeed, setSucceed] = useState(false);
  const [failed, setFailed] = useState(false);
  const [isTestBox, setIsTestBox] = useState(true);

  return (
    <Jumbotron>
      <Col>
        <Row>
          <h1>Update box</h1>
        </Row>
        <Row style={{ marginTop: 20, marginBottom: 20 }}>
          <h2>Update</h2>
          <input
            placeholder="MAC Address"
            type="text"
            onChange={({ target: { value } }) => setMacAddress(value)}
            value={macAddress}
          />
          <h2>to</h2>
          <input
            placeholder="Target Version"
            type="text"
            onChange={({ target: { value } }) => setTargetVersion(value)}
            value={targetVersion}
          />
          {
          loading
            ? <Spinner color="primary" style={{ marginLeft: 50 }} />
            : (
              <Button
                color="success"
                onClick={
                  () => {
                    setSucceed(false);
                    setFailed(false);
                    setTargetVersionToBox({ variables: { macAddress, targetVersion, isTestBox } })
                      .then(() => { setFailed(false); setSucceed(true); })
                      .catch((error) => {
                        console.error(error);
                        setFailed(true);
                        setSucceed(false);
                      });
                  }
                }
                style={{ marginLeft: 30 }}
              >
                Set target version
              </Button>
            )
        }
        </Row>
        <Row style={{ alignItems: 'center' }}>
          Set to "testGroup=other" if checked
          <br />
          Remove it from "testGroup=other" otherwise
          <br />
          (uncheck only if you know what you're doing)
          <input
            name="isTestBox"
            type="checkbox"
            checked={isTestBox}
            onChange={() => setIsTestBox(!isTestBox)}
          />
        </Row>
        {succeed && <Alert color="success">Success!</Alert>}
        {failed && <Alert color="error">Failure :(</Alert>}
      </Col>
    </Jumbotron>
  );
};



// WEBPACK FOOTER //
// ./src/components/ota/OneBoxReleasePanel.js